import { normalizeUserRoles } from './maintenance-mode';

export interface IUserWithRole {
  role?: string | string[] | null;
}

export function userHasRole(user: IUserWithRole | null | undefined, role: string): boolean {
  return normalizeUserRoles(user?.role).includes(role);
}

export function userHasAdminRole(user: IUserWithRole | null | undefined): boolean {
  return userHasRole(user, 'admin');
}

export function isAdminRoute(path: string): boolean {
  return path === '/admin' || path.startsWith('/admin/');
}
